export const SET_NAME_PRINTERS = 'SET_NAME_PRINTERS'
export const SET_PRINTERS = 'SET_PRINTERS'
export const APPEND_PRINTERS = 'APPEND_PRINTERS'
export const SET_PRINTERS_LENGTH = 'SET_PRINTERS_LENGTH'
export const SET_PRINTER = 'SET_PRINTER'
export const SET_PRINTERS_UPDATE_TRIGGER = 'SET_PRINTERS_UPDATE_TRIGGER'
export const SET_PRINTER_RESTAURANT_BOUND_IS_SKELETON = 'SET_PRINTER_RESTAURANT_BOUND_IS_SKELETON'
